import Routine, { RUN } from "+/Engine/Routine";
import DataTypes from "+/Engine/Helpers/DataTypes";

export default class TriggerEvent extends Routine {
  assertValidParams(params) {
    DataTypes.assertObjectKeyExistsOfType("eventName", params, DataTypes.assertString);
    DataTypes.assertObjectKeyExistsOfType("eventParams", params, DataTypes.assertObject);
  }

  [RUN](params, contexts) {
    return this.app.triggerEventWithoutSendingToServer(params.eventName, params.eventParams, contexts);
  }
}

Routine.register("TriggerEvent", TriggerEvent);
